import {HttpUtils} from "@/api/common/HttpUtils";
import {UserService} from "@/api/modules/userManagement/services/UserService";
import {required, sameAs} from "vuelidate/lib/validators";
import {MarketingMaterialItem} from "@/api/modules/marketingMaterial/models/MarketingMaterialItem";
import {MarketingMaterial} from "@/api/modules/marketingMaterial/MarketingMaterial";


export default {
    name: "MarketingMaterialUpload",
    data() {
        return {
            form:{
                companyId: '',
                name: '',
                description: '',
                fileId: '',
                readonly: false
            },
            confirmation:{
                show: false,
            },

            isLoading: false,
            companies: []
        }
    },
    validations : {
        form: {
            companyId: { required },
            name: { required },
            description: { required }
        }
    },
    mounted() {
    },
    created(){
        this.uploadHeaders = HttpUtils.getHttpHeaders(this.$store.state.auth);

        let service = new UserService(this.$store.state.auth, (e) => {
            console.error(e)
        });

        service.getCompanies().then(companies => {
                if (companies != null) {
                    this.companies = companies;
                }
            }
        ).catch(error => {
            this.$notify.error({
                title: 'Internal Error',
                message: 'Unable to retrieve companies list.'
            });
        });
    },
    computed: {
        uploadUrl(){
            return `${process.env.VUE_APP_API_URL}/v1/marketing-materials/companies/${this.form.companyId}/upload`;
        },
        uploadButtonVisible() {
            return this.form.companyId !== '';
        }
    },
    methods: {
        onUploadSuccess(res, file, fileList){
            this.form.fileId = res;
        },
        onSubmit(){
            let marketingMaterialItem = new MarketingMaterialItem(this.form.companyId);
            marketingMaterialItem.name = this.form.name;
            marketingMaterialItem.description = this.form.description;
            marketingMaterialItem.fileId = this.form.fileId;

            let marketingMaterial = new MarketingMaterial(this.$store.state.auth);
            marketingMaterial.save(marketingMaterialItem).then(
              item => {
                  this.confirmation.show = true;
                  this.form.readonly = true;

              }
            ).catch(err => {

                this.$notify.error({
                    title: 'Internal Error',
                    message: 'An error occurred when saving your file!.'
                });
            })
        },
        onCancel() {
            this.form.companyId = '';
            this.form.name = '';
            this.form.description = '';
            this.form.fileId = '';
            this.form.readonly = false;
            this.confirmation.show = false;
        },
        onUploadError(err, file, fileList){
            this.$notify.error({
                title: 'Internal Error',
                message: 'An error occurred when uploading your file!.'
            });

            console.error(err);
        }
    }

}